<template>
	<div class="sf-input-group-wrapper">
		<span class="sf-input-group-wrapper__label">{{ getMessage_('QWCC001163') }}</span>
		<div class="search-option-wrapper__normal">
			<el-select v-model="data" @change="change">
				<el-option :label="getMessage_('MWCC000753')" value=""></el-option>
				<el-option :key="index" v-for="(useYn, index) in useYnList" :label="useYn.commCdName" :value="useYn.commCd"></el-option>
			</el-select>
		</div>
	</div>
</template>

<script>
import { rootComputed } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@/views/qms/comm/qmsbase/Variable/store/helpers';
export default {
	data() {
		return {
			data: null
		};
	},
	computed: {
		...rootComputed,
		...serviceComputed
	},
	methods: {
		...serviceMethods,
		change(value) {
			this.setSearchParam_({ key: 'useYn', value: value }).then(() => {
				this.$emit('reload', 1, 10);
			});
		}
	},
	created() {
		if (this.searchParams.useYn == null || this.searchParams.useYn == '') this.searchParams.useYn = 'Y';
		this.data = this.searchParams.useYn;
	}
};
</script>

<style></style>
